<div style="width: 100%; height: 60px;">
    <div style="float:right; width: 180px; cursor: pointer;" (click)="onEmail()">
        <img src="../../assets/email.png" alt="Share with email" style="width: 48px; height: auto; vertical-align: middle;">
        <span style="vertical-align: middle;font-weight: bold;margin-left:10px; font-size: 22px;">Email</span>
    </div>
    <!--
    <div class="searchbar" >
        <input class="searchbox" (input)="onSearchTextChanged()" type="text"  [(ngModel)]="this.searchtext" placeholder="Enter date, title or category name to search"/>
        <a href="https://chrome.google.com/webstore/detail/google-input-tools/mclkkofklkfljcocdinagocijmpgbhab?hl=en" target="_blank"> Change input language</a> 
    </div>
    -->
</div>

<div class="appLable" style="font-weight: bold;font-size: 18px; text-align: center;">{{cat.DocumentCategoryName}}</div>
<div class="clearfix" style="background-color: black; color: white;">
    <ul >
        <li>Date</li>
        <li>Title</li>
        <li>Category</li>
        <li>
            <input type="button" value="View Details" class="appButton" style="float: right; margin: 5px; ">
        </li>
    </ul>
</div>
<div *ngFor="let doc of docs" class="clearfix" style="background-color: #bbb;">
    <li>{{doc.documentdate * 1000 | date:'dd/MM/yyyy'}}</li>
    <li>{{doc.title}}
        <img  (click)="onViewPropertyDocumentDetails(doc)" *ngIf="doc.isnotarized" src="../../assets/seal.png" alt="Share with email" style="width: 24px; height: auto; cursor: pointer; vertical-align: middle;">
    </li>
    <li>{{doc.cat.DocumentCategoryName}}</li>
    <li>
        <input type="button" value="View Document" class="appButton" style="float: right; margin: 5px; " (click)="onViewDocument(doc)">
    </li>
</div>

